import { getArticles, fetchApi } from "./requests";
import { parseCookies } from "nookies";
import { flattenResponsesArray } from "../services/arrays";

export const getLayoutProps = async () => {
  const navbarLinks = await fetchApi({ url: "pages-link-list/42" });
  const submenuResponse = navbarLinks[0]
    ? await getSubmenuLists(navbarLinks[0].links)
    : [];
  const submenuLists = flattenResponsesArray(submenuResponse);
  const [importantArticles] = await fetchApi({
    url: `articles-important-topic/?site=12&limit-articles=1`,
  });
  const mainCategories = await fetchApi({
    url: `articles-category/?only_main=True&site=12`,
  });
  const paths = await fetchApi({ url: "seo-path/?site=12&limit: 60" });
  return {
    navbarLinks,
    submenuLists,
    importantArticles,
    mainCategories,
    paths,
  };
};

export const getSubmenuLists = async (links) => {
  const linksWithSubmenu = links.filter((el) => el.submenu);
  const promisses = linksWithSubmenu.map(async (el) =>
    fetchApi({ url: `pages-submenu-list/${el.submenu}` })
  );
  const submenuLists = await Promise.all(promisses);
  return submenuLists;
};

export const getArticleBySlug = async (slug, userId) => {
  const [article, err] = await fetchApi({
    url: `articles-article?slug=${slug}`,
  });
  if (article && article.count) {
    const id = article.results[0].id;
    const params = userId ? `?user_id=${userId}` : "";
    const articleData = await fetchApi({
      url: `articles-article/${id}${params}`,
    });
    return articleData;
  } else {
    return [null, { err: "Article doesn't exist" }, { status: 404 }];
  }
};

export const reloadArticle = async (slug, token) => {
  const [me] = await fetchApi({
    url: `auth-me`,
    token,
  });
  let userId;
  if (me && me.count) {
    userId = me.results[0].profile.user.id;
  }
  const articleData = await getArticleBySlug(slug, userId);
  return articleData;
};

export const getFullCategoriesData = async (categorySlug) => {
  const [categoryData] = await fetchApi({
    url: `articles-category/?slug=${categorySlug}`,
  });
  if (categoryData && categoryData.count > 0) {
    const category = categoryData.results[0];
    const { main_category } = category;
    const [mainCategory] = main_category
      ? await fetchApi({
          url: `articles-category/${main_category.id}`,
        })
      : [null];
    const mainCategoryId = main_category ? main_category.id : category.id;
    const subcategories = await getSubcategoriesList(mainCategoryId);
    return { category, mainCategory, subcategories };
  } else {
    return { category: null, mainCategory: null, subcategories: null };
  }
};

export const getSubcategoriesList = async (mainCategoryId) => {
  const [subcategories] = await fetchApi({
    url: `articles-category/?main_category=${mainCategoryId}`,
  });
  return subcategories;
};
export const getAgrarsklepProduct = async (articleId) => {
  const [data, err] = await fetchApi({
    url: `articles-agrarsklep-sidebar/${articleId}`,
  });
  if (data && data.agrarsklep_product) {
    const agrarsklepData = await fetchApi({
      url: `blocks-agrarsklep-product/${data.agrarsklep_product}`,
    });
    return agrarsklepData;
  } else {
    return [null];
  }
};

export const getUserIdFromCookies = async (context) => {
  const cookie = parseCookies(context);
  let userId = null;
  if (cookie.userToken) {
    const [userData] = await fetchApi({
      url: "/auth-me/",
      token: cookie.userToken,
    });
    if (userData && userData.count) {
      userId = userData.results[0].profile.user.id;
    }
  }
  return userId;
};
